import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorLogoUploadEffects {
	update = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.vendorLogo.upload),
			switchMap((action) =>
				this.vendorAdminService.uploadLogo(action.formData).pipe(
					map(() =>
						VendorAdminActions.vendorLogo.uploadSuccess({ vendorId: action.vendorId })
					),
					catchError((error) =>
						of(VendorAdminActions.vendorLogo.uploadFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorAdminService: VendorAdminService
	) {}
}
